<template>
    <div class="empty component">
      <img v-if="text !== 'error'" :src="imageSrc" alt="empty"/>
      <p class="message text-sub-color">{{ displayText }}</p>
      <button v-if="text === 'error'" class="purchase-button" :style="disabled ? { background: '#ddd' } : {}" @click="refresh">
        再読み込み
      </button>
    </div>
  </template>
  
<script>
export default {
  name: 'Empty',
  props: {
    type: { type: String, default: 'note' }, // film, bulb, note
    text: { type: String, default: 'schedule' },
    disabled: { type: Boolean, default: false }
    // text: { type: String, default: 'Sorry, no information was found ！' }
  },
  computed: {
    imageSrc () {
      return require(`../../assets/images/${this.type}.svg`)
    },
    displayText () {
      switch (this.text) {
        case 'film':
          return this.$i18n.messages[this.$i18n.fallbackLocale].null.film
        case 'error':
          return this.$i18n.messages[this.$i18n.fallbackLocale].null.error
        default:
          return this.$i18n.messages[this.$i18n.fallbackLocale].null.schedule
      }
    }
  },
  methods: {
    refresh () {
      this.$emit('refresh')
    }
  }
}
</script>
  
  <style lang="scss" scoped>
    .empty {
      text-align: center;
  
      img {
        margin-top: 40px;
      }
  
      .message {
        margin: 40px 0;
        font-size: 20px;
        font-weight: 500;
        letter-spacing: 0.9px;
        opacity: .5;
      }
      .purchase-button {
        min-width: 80px;
        border: 0 solid;
        border-radius: 3px;
        color: black !important;
        // color: var(--Button-font-color);
        font-size: 14px;
        font-weight: 500;
        line-height: normal;
        letter-spacing: 0.63px;
        padding: 2px 15px;
      }
    }
  </style>
